import { atom } from 'recoil';

export const UserAgentDetailState = atom<any>({
	key: 'user-agent-detail-state',
	default: {},
});
